import Footer from '../../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Container, Divider, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../../Components/DrawerAppBar';
import Menus from '../../Components/Menus';
import TitrePage from '../../Components/TitrePage';
import { TextFields } from '@mui/icons-material';
import React from 'react';
import EllipseGauche from "../../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../../Fichiers/Ellipse 201.svg"
import illution_4 from "../../Fichiers/illution_4.svg";

interface Props { }

function PretImobilier(props: Props) {
        const { t } = useTranslation();
        

    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre29'} lien={'Label.Titre.titre10'} />
            <br /><br /><br /><br /><br /><br /><br /><br />



            <Box display={"flex"} lineHeight={1.6} textAlign={"justify"}>
                <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseGauche} alt="" />

                <Container maxWidth='lg'>

                    <Box>

                        <Box textAlign={"justify"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <img width={"100%"} src={illution_4} alt="" /><br />

                            </motion.div>
                            <label style={{ fontSize: 'xx-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("CREDIT_IMMOBILIER.texte.partie1").toUpperCase()}</label>
                            <br />
                            <label className='textgray' style={{ fontSize: 'large' }} htmlFor="">
                                {t("CREDIT_IMMOBILIER.texte.partie2")}
                            </label>
                            <br /><br />

                        </Box>
                    </Box>
                    <br />
                    <label className='textgray' style={{ fontSize: 'large' }} htmlFor="">
                        {t("CREDIT_IMMOBILIER.texte.partie2")}
                    </label>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }}>

                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <Box gap={20}>
                                <motion.div
                                    whileHover={{ scale: 1, rotate: 1 }}
                                    whileTap={{
                                        scale: 1,
                                        rotate: -1,
                                    }}
                                >
                                    <img style={{ borderRadius: "10%" }} width={'100%'} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                                </motion.div>
                            </Box>
                        </motion.div>
                        <Box width={100} />
                        <Box width={"100%"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >

                                <img width={"50%"} src={illution_4} alt="" /> <br />
                                <label className='textgray' htmlFor="" style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }}>
                                    {t("CREDIT_IMMOBILIER.texte.partie3").toUpperCase()}
                                </label>
                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                                    {t("CREDIT_IMMOBILIER.texte.partie4")}
                                </label>
                            </motion.div>


                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie9")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("CREDIT_IMMOBILIER.texte.partie10").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                            <i>{t("CREDIT_IMMOBILIER.texte.partie11")}</i>
                        </label>
                    </motion.div>
                    <br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("CREDIT_IMMOBILIER.texte.partie5").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                                    {t("CREDIT_IMMOBILIER.texte.partie6")}
                                </label><br />
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie12")}
                        </label><br />
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ fontWeight: "bold" }} htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie13")}
                        </label><br />
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("CREDIT_IMMOBILIER.texte.partie14").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ fontWeight: "bold" }} htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie15")}
                        </label><br />
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("CREDIT_IMMOBILIER.texte.partie16").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ fontWeight: "bold" }} htmlFor="">
                            <i>{t("CREDIT_IMMOBILIER.texte.partie17")}</i>
                        </label><br />
                    </motion.div>
                    <br /><br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("CREDIT_IMMOBILIER.texte.partie7").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={{ xs: 'block', sm: 'flex' }} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("CREDIT_IMMOBILIER.texte.partie8")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={400} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie18")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("CREDIT_IMMOBILIER.texte.partie19").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>

                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie20")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("CREDIT_IMMOBILIER.texte.partie21").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>

                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("CREDIT_IMMOBILIER.texte.partie22")}
                        </label>
                    </motion.div>

                    <img width={"50%"} src={illution_4} alt="" />
                    <br /><br />
                </Container>
                <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseDroite} alt="" />
            </Box>

            <Footer />
        </div>
    )
}
export default PretImobilier